/**
 * BIES Volume Selector
 * Sistema de descuentos por volumen usando productos bundle
 *
 * Cuando el usuario selecciona 2/3/4 unidades, se añade el producto bundle
 * correspondiente en lugar del producto individual.
 */

(function() {
  'use strict';

  // Use shared bundle map (loaded from bies-bundle-map.js)
  const BUNDLE_VARIANTS = window.BIES_BUNDLE_VARIANTS || {};

  class BiesVolumeSelector {
    constructor(container) {
      this.container = container;
      this.options = container.querySelectorAll('.bies-volume-selector__option');
      this.productId = container.dataset.productId;
      this.variantId = container.dataset.variantId;
      this.bundleCode = container.dataset.bundleCode;
      this.selectedQuantity = 1;

      // Obtener bundle variants del mapeo
      this.bundleVariants = BUNDLE_VARIANTS[this.bundleCode] || {};

      // Referencia al input de variant del formulario principal (buy-buttons)
      // Usamos la clase específica 'product-variant-id' para evitar el input de installment
      this.variantInput = document.querySelector('input.product-variant-id');

      // Referencia al formulario principal
      this.productForm = document.querySelector('form[data-type="add-to-cart-form"]');

      // Referencia al input de cantidad
      this.quantityInput = document.querySelector('.quantity__input') ||
                           document.querySelector('input[name="quantity"]');

      console.log('[BIES Volume] Initialized for product:', this.productId);
      console.log('[BIES Volume] Variant input found:', !!this.variantInput);
      console.log('[BIES Volume] Product form found:', !!this.productForm);
      console.log('[BIES Volume] Bundle code:', this.bundleCode);
      console.log('[BIES Volume] Bundle variants:', this.bundleVariants);

      this.init();
    }

    init() {
      this.bindEvents();
    }

    bindEvents() {
      // Click en opciones
      this.options.forEach(option => {
        option.addEventListener('click', (e) => this.handleOptionClick(e, option));
      });

      // Interceptar envío del formulario
      const form = document.querySelector('form[action="/cart/add"]') ||
                   document.querySelector('.product-form');

      if (form) {
        form.addEventListener('submit', (e) => this.handleFormSubmit(e, form));
      }
    }

    handleOptionClick(e, option) {
      const previousQuantity = this.selectedQuantity;
      // Quitar selección de todas las opciones
      this.options.forEach(opt => opt.classList.remove('is-selected'));

      // Seleccionar la opción clickeada
      option.classList.add('is-selected');

      // Marcar el radio button
      const radio = option.querySelector('input[type="radio"]');
      if (radio) {
        radio.checked = true;
      }

      // Actualizar cantidad seleccionada
      this.selectedQuantity = parseInt(option.dataset.quantity, 10);

      console.log('[BIES Volume] Selected quantity:', this.selectedQuantity);

      // Actualizar el variant ID si hay bundle disponible
      this.updateVariantId();

      // Track analytics
      this.trackAnalytics('volume_option_selected', {
        quantity: this.selectedQuantity,
        tier: option.dataset.tier,
        using_bundle: this.selectedQuantity > 1 && this.bundleVariants[this.selectedQuantity]
      });

      // Selection is an offer interaction, never evidence of a cart purchase.
      if (previousQuantity !== this.selectedQuantity) document.dispatchEvent(new CustomEvent('bies:volume:selected', { detail: {
        offer_id: String(this.productId || ''),
        offer_version: String(option.closest('.bies-volume-selector')?.dataset.biesOfferVersion || 'volume-v1')
      } }));
    }

    updateVariantId() {
      if (!this.variantInput) {
        console.error('[BIES Volume] ERROR: variantInput not found!');
        return;
      }

      if (this.selectedQuantity === 1) {
        // Usar producto original con cantidad 1
        this.variantInput.value = this.variantId;
        this.setQuantity(1);
        console.log('[BIES Volume] Using original variant:', this.variantId);
      } else {
        // Usar bundle si está disponible
        const bundleId = this.bundleVariants[this.selectedQuantity];
        if (bundleId) {
          // Cambiar al producto bundle
          this.variantInput.value = bundleId;
          // El bundle ya contiene X unidades, así que la cantidad debe ser 1
          this.setQuantity(1);
          console.log('[BIES Volume] Using bundle variant:', bundleId, '(quantity set to 1)');
        } else {
          // Fallback: usar producto original con la cantidad seleccionada
          this.variantInput.value = this.variantId;
          this.setQuantity(this.selectedQuantity);
          console.log('[BIES Volume] No bundle available, using original with quantity:', this.selectedQuantity);
        }
      }
    }

    setQuantity(qty) {
      if (this.quantityInput) {
        this.quantityInput.value = qty;
        // Disparar eventos para que el tema lo detecte
        this.quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
        this.quantityInput.dispatchEvent(new Event('input', { bubbles: true }));
      }
    }

    handleFormSubmit(e, form) {
      // Asegurar que el variant ID y cantidad están correctos antes del submit
      console.log('[BIES Volume] Form submitting with variant:', this.variantInput?.value, 'quantity:', this.quantityInput?.value);

      // El variant ID y la cantidad ya están configurados en updateVariantId()
      // Solo logueamos para debugging
      const bundleId = this.bundleVariants[this.selectedQuantity];
      if (bundleId) {
        console.log('[BIES Volume] Submitting bundle:', bundleId);
      }
    }

    trackAnalytics(eventName, data) {
      // Google Analytics / GA4
      if (window.dataLayer) {
        window.dataLayer.push({
          event: 'bies_volume_' + eventName,
          ...data
        });
      }

      // Klaviyo
      if (window._learnq) {
        window._learnq.push(['track', 'Volume Discount ' + eventName, data]);
      }
    }
  }

  // Inicializar cuando el DOM esté listo
  function init() {
    const containers = document.querySelectorAll('.bies-volume-selector');
    containers.forEach(container => {
      if (!container.dataset.initialized) {
        new BiesVolumeSelector(container);
        container.dataset.initialized = 'true';
      }
    });
  }

  // Inicializar
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-inicializar si hay cambios dinámicos
  document.addEventListener('shopify:section:load', init);

})();
